/**************************************************
 * Nombre:       Formulario_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {GeneratingTokensOutlined, MoneyOutlined} from "@mui/icons-material";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";
import {CRYPTOS} from "../../Constantes";
import {useEffect, useState} from "react";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import {QRCodeSVG} from 'qrcode.react';
import IngresoImagen from "../../Modulo_formularios/Componentes/IngresoImagen";
import {copiarPortapapeles} from "../../CodigoCliente/Funciones/copiarPortapapeles";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Formulario_Deposito = ({...props}) => {
    const {sCell} = useResponsive()
    const {Avisos, nuevoAviso, terminar} = useCargador({logoRedondo: ''})
    const [crypto, setCrypto] = useState({});
    const [billetera, setBilletera] = useState({});


    useEffect(() => {

        if (crypto) {

            let index = CRYPTOS.findIndex((e) => e.nombre === crypto);
            if (index > -1) {
                setBilletera(CRYPTOS[index]);
            }

        }
    }, [crypto]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Avisos/>

                <Grid container size={6}>
                    <IngresoDinero Icono={MoneyOutlined} nombre={'Valor en USD'} dato={'valor'} {...props}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelectFuncion Icono={GeneratingTokensOutlined} nombre={'Tipo de Crypto'}
                                          dato={'tipo'} {...props}
                                          opciones={CRYPTOS.map((it) => it.nombre)}
                                          setDato={setCrypto}
                                          requerido={'El tipo de Crypto es requerido'}
                    />
                </Grid>

                {billetera.key &&

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'center'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            <Grid container size={{xs: 12, sm: 12, md: 5}}
                                  sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                                <QRCodeSVG value={billetera.key}/>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'flex-start'}}>
                                <Grid
                                    container
                                    justifyContent={'center'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                        <Typography
                                            sx={{wordBreak: 'break-word', textAlign: 'center'}}
                                        >{billetera.key}</Typography>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                        <Button
                                            onClick={() => copiarPortapapeles(billetera.key).then(() => {
                                                terminar({aviso: 'Copiado a portapapales'})
                                            })}
                                            sx={{px: 2, py: 0.5}} variant={'outlined'}>Copiar</Button>
                                    </Grid>

                                </Grid>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                <Typography sx={{fontWeight: 600}}>Envío de Captura de Pantalla</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                <IngresoImagen dato={'img'} {...props} />
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontSize: 12}}>**La validación puede tardar hasta 12 horas, podrás ver
                                    el estado de ésta en la sección historial (historial de transacciones)</Typography>
                            </Grid>


                        </Grid>

                    </Grid>


                }

            </Grid>

        </form>

    )

}
export default Formulario_Deposito    